export default __webpack_public_path__ + "static/media/lipizzaner-logo-transparent.a959febf.png";